package pl.mothdigital.neuronowi.pages.therapies.fizjoterapia

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyPhysioPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Fizjoterapia",
            icon = { FaPersonRunning() },
            description = "Diagnoza i rehabilitacja układu ruchu, terapia bólu oraz usprawnianie po urazach i zabiegach operacyjnych.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest fizjoterapia?",
                    content = """
                        Fizjoterapia to dziedzina medycyny zajmująca się diagnozą, terapią i profilaktyką
                        dysfunkcji układu ruchu. W Centrum Terapii NeuroNowi oferujemy kompleksową fizjoterapię
                        dla dzieci, młodzieży i dorosłych, stosując nowoczesne metody terapeutyczne dostosowane
                        do indywidualnych potrzeb każdego pacjenta.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest fizjoterapia?",
                    content = """
                        Fizjoterapia jest pomocna dla osób z:

                        • Zaburzeniami postawy ciała (skolioza, kifoza, lordoza)
                        • Bólami kręgosłupa i stawów
                        • Urazami sportowymi i pourazowymi
                        • Opóźnieniami rozwoju psychoruchowego u dzieci
                        • Zaburzeniami neurologicznymi (porażenie, pareza)
                        • Problemami z równowagą i koordynacją
                        • Dysfunkcjami po zabiegach operacyjnych
                        • Chorobami reumatycznymi
                        • Zaburzeniami motoryki dużej
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi fizjoterapia?",
                    content = """
                        Prawidłowo prowadzona fizjoterapia może przynieść wiele korzyści:

                        • Poprawę siły i wytrzymałości mięśni
                        • Zwiększenie zakresu ruchu w stawach
                        • Redukcję bólu i napięć mięśniowych
                        • Poprawę postawy ciała
                        • Lepszą koordynację i równowagę
                        • Zwiększenie sprawności funkcjonalnej
                        • Przyspieszenie procesu regeneracji
                        • Profilaktykę kontuzji i urazów
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega fizjoterapia?",
                    content = """
                        Proces fizjoterapii w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową ocenę fizjoterapeutyczną - badanie postawy, zakresu ruchu,
                           siły mięśniowej i funkcji motorycznych.

                        2. Opracowanie indywidualnego planu terapeutycznego dostosowanego do diagnozy
                           i celów terapeutycznych.

                        3. Regularne sesje fizjoterapeutyczne z wykorzystaniem różnorodnych technik
                           i metod terapeutycznych.

                        4. Edukację pacjenta i rodziny dotyczącą ćwiczeń domowych oraz ergonomii
                           w codziennym funkcjonowaniu.

                        5. Monitorowanie postępów i modyfikację programu terapeutycznego w zależności
                           od uzyskanych efektów.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W fizjoterapii stosujemy szeroką gamę technik i metod:

                        • Kinesioterapię (terapię ruchem)
                        • Terapię manualną i mobilizację stawów
                        • Ćwiczenia korekcyjne postawy
                        • Proprioceptive Neuromuscular Facilitation (PNF)
                        • Elementy metody Bobath i Vojty
                        • Terapię na piłkach i materacach niestabilnych
                        • Fizykoterapię (ultradźwięki, elektroterapia)
                        • Ćwiczenia w odciążeniu i na sprzęcie rehabilitacyjnym
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Fizjoterapię w naszym centrum prowadzą doświadczeni fizjoterapeuci z odpowiednimi
                        kwalifikacjami i wieloletnim doświadczeniem w pracy z pacjentami w różnym wieku.
                        Nasi specjaliści posiadają dodatkowe certyfikaty w zakresie fizjoterapii pediatrycznej,
                        neurologicznej i ortopedycznej, regularnie uczestniczą w szkoleniach, aby zapewnić
                        pacjentom dostęp do najnowocześniejszych metod rehabilitacji.
                    """.trimIndent()
                )
            )
        )
    )
}
